// @ts-check

// @ts-ignore
import { createStore } from 'fe-lib-store';
import { brand2020 } from './themes/brand2020/brand2020';
import { rebrand2022Theme } from './themes/rebrand2022/rebrand2022';
import { getThemeName, setThemeName } from './localStorage';

const themes = {
  [brand2020.name]: brand2020,
  [rebrand2022Theme.name]: rebrand2022Theme,
};

const DEFAULT_THEME_NAME = brand2020.name;
const NAMESPACE = 'fe-lib-theme-provider';
const LS_THEME = getThemeName(DEFAULT_THEME_NAME);

const initialState = themes[LS_THEME] || brand2020;

const handlers = {
  useTheme: (_store, themeName, persist) => {
    if (persist) {
      setThemeName(themeName);
    }
    return themes[themeName] || themes[DEFAULT_THEME_NAME];
  },
};

const { dispatch, getState, subscribe } = createStore(
  NAMESPACE,
  handlers,
  initialState,
);
export { dispatch, getState, subscribe };
